// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  display: flex;
}
.footer #jedi_hr_logo {
  width: 400px;
}
.footer .footer_right {
  width: 100%;
  height: 73.88px;
  background-color: #fede8c;
}
@media (max-width: 400px) {
  .footer #jedi_hr_logo {
    width: 100%;
  }
  .footer .footer_right {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/footer.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;AADJ;AAGI;EACI,YAAA;AADR;AAGI;EACI,WAAA;EACA,eAAA;EACA,yBAAA;AADR;AAII;EACI;IACI,WAAA;EAFV;EAIM;IACI,aAAA;EAFV;AACF","sourcesContent":["@import \"./variables.scss\";\n\n.footer {\n    display: flex;\n\n    #jedi_hr_logo {\n        width: 400px;\n    }\n    .footer_right {\n        width: 100%;\n        height: 73.88px;\n        background-color: #fede8c;\n    }\n\n    @media (max-width: 400px) {\n        #jedi_hr_logo {\n            width: 100%;\n        }\n        .footer_right {\n            display: none;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
